import { put, select, call } from 'typed-redux-saga'
import { AnyAction } from 'redux'

import services from '@services'
import { ApplicationState } from '@store/types'
import { showError } from '@store/ui/error/actions'
import { setLastServiceResponse } from '@store/session/actions'
import { StepRefin } from '@utils/enums'
import { HttpStatus } from '@services/base'
import { BridgeService } from '@services/bridge'
import { logout } from '@utils/functions'
import { ErroType } from '@utils/types'
import { PostPropostaFinalizarWebServiceType } from '@services/postPropostaFinalizarAppService'

import { finalizarPropostaErro, finalizarPropostaSuccess } from '../actions'

export default function* postFinalizarPropostaSaga({ payload }: AnyAction) {
  const { numeroProposta } = yield* select(
    (state: ApplicationState) => state.refinanciamento.proposta,
  )
  const { cpfDadosPessoais } = yield* select(
    (state: ApplicationState) => state.refinanciamento.dadosPessoais,
  )
  const { email, telefone } = yield* select(
    (state: ApplicationState) => state.refinanciamento.contato,
  )
  const { accessToken } = yield* select((state: ApplicationState) => state.session)

  try {
    const service = BridgeService.isBrowser()
      ? services.postPropostaFinalizarWebService
      : services.postPropostaFinalizarAppService

    yield* call(
      service as PostPropostaFinalizarWebServiceType,
      {
        codigoProposta: String(numeroProposta),
        cpf: cpfDadosPessoais ?? '',
        email,
        telefone,
        produto: 'Refinanciamento',
      },
      accessToken,
    )

    yield put(
      setLastServiceResponse({
        code: 'OK',
        serviceName: BridgeService.isBrowser()
          ? 'postPropostaFinalizarWebService'
          : 'postPropostaFinalizarAppService',
      }),
    )
    yield put(finalizarPropostaSuccess())
    yield payload.callback()
  } catch (error) {
    yield put(
      setLastServiceResponse({
        code: 'ERROR',
        serviceName: BridgeService.isBrowser()
          ? 'postPropostaFinalizarWebService'
          : 'postPropostaFinalizarAppService',
      }),
    )
    yield put(finalizarPropostaErro())
    const erroTyped = error as ErroType
    if (BridgeService.isBrowser() && erroTyped.status === HttpStatus.UNAUTHORIZED) {
      yield put(
        showError({
          title: 'Sessão expirada',
          message: 'Efetue o login novamente.',
          actionTitle: 'Continuar',
          functionCallback: () => logout(),
        }),
      )
    } else if (erroTyped.status === HttpStatus.NOT_FOUND) {
      yield put(
        showError({
          title: 'Ocorreu um erro',
          message: 'Ocorreu um erro ao validar o envio da biometria, por favor tente novamente.',
          functionCallback: () => payload.callbackTryAgain(),
          actionTitle: 'Refazer biometria',
          code: StepRefin.ERRO_FINALIZAR_PROPOSTA,
          block: true,
        }),
      )
    }
  }
}
